<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ props: { disabled: disableSubmit } }"
    @cancel="handleCancel"
    cancelText="关闭">
    <efs-std-standard-cycle-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></efs-std-standard-cycle-form>
  </j-modal>
</template>

<script>

  import EfsStdStandardCycleForm from './EfsStdStandardCycleForm'
  export default {
    name: 'EfsStdStandardCycleModal',
    components: {
      EfsStdStandardCycleForm
    },
    data () {
      return {
        title:'',
        width:1450,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      setCompanyCode(){},
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.handleOk();
        // this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>